"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * HOC for Button
 */
var CarInfoBook = function (props) {
    var bookFormUrl = props.bookFormUrl, query = props.query, children = props.children, dispatch = props.dispatch, // Just for omit dispatch from restProps
    restProps = __rest(props, ["bookFormUrl", "query", "children", "dispatch"]);
    var resolvedQuery = encodeURI(query);
    var href = bookFormUrl + "?" + resolvedQuery;
    return react_1.cloneElement(children, __assign({ href: href }, restProps));
};
CarInfoBook.displayName = 'CarInfoBook';
exports.default = CarInfoBook;
